import { render } from "./spinners.vue?vue&type=template&id=2d10c752"
import script from "./spinners.vue?vue&type=script&lang=js"
export * from "./spinners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__